// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__OIWya","content":"GlobalSearch_content__1vXd7"};